module.exports = __webpack_public_path__ + "img/prof-dr-hab-Pawel-Urbanski.52558911.jpg";